module.exports = __webpack_public_path__ + "img/15.9faa6c03.jpg";